import React, { useEffect, useState } from 'react';

export default function LoadMore({ setLimit, limit, cutsList }) {
  const [end, setEnd] = useState(false);
  const [clickDetected, setClickDetected] = useState(false);

  const handleLimitChange = () => {
    setClickDetected(true);

    setLimit((currentLimit) => {
      if (currentLimit >= cutsList.length) {
        setEnd(true);
        return currentLimit;
      }
      return currentLimit + 12;
    });
  };

  useEffect(() => {
    if (cutsList.length < limit || cutsList.length - limit <= 0) {
      setEnd(true);
    }

    setClickDetected(false);
  }, [cutsList, clickDetected]);

  return (
    <section className="section u--padding-top-0 u--padding-bottom-50">
      <div className="full-divider container">
        <p className="u--text-align-center">
          <button
            onClick={() => handleLimitChange()}
            className={`btn btn--loose cuts__load-button ${
              end ? 'cut-card__hide-button' : ''
            }`}
          >
            <span>Load More</span>
          </button>
        </p>
      </div>
    </section>
  );
}
